import { tokenize } from '../../../shared/html-source-tokens.js';

export const ESP_TAG_ROLES = ['unsubscribe', 'preference_center', 'view_in_browser', 'personalization', 'link'];
export function validateEspHandTag({ token, role, esp }) {
  const valid = esp === 'sfmc' ? /^%%[A-Za-z_][A-Za-z0-9_]{0,127}%%$/ : esp === 'hubspot' ? /^\{\{\s*[A-Za-z_][A-Za-z0-9_.]{0,127}\s*\}\}$/ : false;
  if (typeof token!=='string'||/[\r\n]/.test(token)||!valid || !valid.test(token) || !ESP_TAG_ROLES.includes(role)) throw Error('Use one literal merge token from the selected supported platform and a supported purpose. Executable expressions and markup are not accepted.');
  return { token, role };
}

// Advisory draft compiler only. The authenticated amendment path independently
// checks exact revision, HTML safety, scope and mandatory whole-email QA.
export function espHandTagSlots(html, block) {
  if (typeof html !== 'string' || block?.identity !== 'authored' || !block.range || !Number.isSafeInteger(block.range.start)||!Number.isSafeInteger(block.range.end)||block.range.start<0||block.range.end<=block.range.start||block.range.end>html.length||html.slice(block.range.start, block.range.end) !== block.code) return [];
  const excluded=new Set(['script','style','xml','textarea','title','head','svg','math']),stack=[];
  return tokenize(html).flatMap(t => {
    if(t.kind==='tag'){
      if(t.close){const at=stack.lastIndexOf(t.name);if(at>=0)stack.splice(at);}
      else if(!t.void)stack.push(t.name);
    }
    if(t.start<block.range.start||t.end>block.range.end||stack.some(name=>excluded.has(name)))return[];
    if (t.kind === 'tag' && !t.close && t.name === 'a') {
      const matches = [...t.raw.matchAll(/\bhref\s*=\s*(["'])(.*?)\1/gi)];
      if (matches.length !== 1 || t.attrs.filter(a => a.name === 'href').length !== 1) return [];
      const m = matches[0], start = t.start + m.index + m[0].indexOf(m[1]) + 1;
      return [{ id: `href:${start}`, kind: 'href', start, end: start + m[2].length, before: m[2], label: `Link destination · ${m[2].slice(0, 80)}` }];
    }
    if (t.kind === 'text' && t.raw.trim() && !/[<>]/.test(t.raw)) return [{ id: `text:${t.start}`, kind: 'text', start: t.start, end: t.end, before: t.raw, label: `Before text · ${t.raw.trim().slice(0, 80)}` }];
    return [];
  });
}

export function compileEspHandTag({ html, block, slotId, token, role, esp }) {
  validateEspHandTag({ token, role, esp });
  const slot = espHandTagSlots(html, block).find(s => s.id === slotId);
  if (!slot || (role === 'personalization' ? slot.kind !== 'text' : slot.kind !== 'href')) throw Error('Choose a current exact placement matching this purpose in an authored block.');
  if (html.slice(slot.start, slot.end) !== slot.before || slot.before === token) throw Error('Placement changed or already contains this token. Reload the saved revision.');
  const after = slot.kind === 'text' ? token + ' ' + slot.before : token;
  return { html: html.slice(0, slot.start) + after + html.slice(slot.end), placement: `${block.id} · ${slot.label}`, scope: 'build', unverified: true };
}
